import React from "react";
import { ShieldCheck, Handshake, Factory, Award } from "lucide-react";

const reasons = [
  { icon: ShieldCheck, title: "Calidad certificada" },
  { icon: Handshake, title: "Compromiso local" },
  { icon: Factory, title: "Fabricaci\u00f3n nacional" },
  { icon: Award, title: "Garant\u00eda oficial" },
];

const NationalProducts = () => (
  <section className="relative py-24 bg-[#F2F2F2] overflow-hidden">
    <div className="absolute -top-32 -left-32 w-96 h-96 bg-[#0A192F]/5 rounded-full blur-3xl"></div>
    <div className="absolute -bottom-32 -right-20 w-96 h-96 bg-[#FFD700]/10 rounded-full blur-3xl"></div>

    <div className="container mx-auto px-4 relative z-10">
      <div className="max-w-3xl mx-auto text-center mb-16">
        <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#0A192F]/10 text-[#0A192F] font-semibold text-sm uppercase tracking-[0.25em]">
          Producto nacional
        </span>
        <h2 className="mt-6 text-4xl md:text-5xl font-bold text-[#0A192F]">
          Trabajamos con materiales 100% nacionales
        </h2>
        <p className="mt-4 text-lg text-[#0A192F]/70 leading-relaxed">
          Garantizamos la máxima calidad y rapidez en cada instalación gracias a una cadena de suministro local y sostenible. Nuestros socios fabricantes comparten nuestra filosofía de excelencia y atención al detalle.
        </p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
        {reasons.map(({ icon: Icon, title }, index) => (
          <article
            key={index}
            className="group bg-white rounded-2xl border border-[#0A192F]/10 p-8 shadow-sm transition-all duration-300 hover:-translate-y-2 hover:shadow-2xl hover:border-[#0A192F]/40 hover:bg-[#0A192F]/95 text-center flex flex-col items-center"
          >
            <div className="w-14 h-14 rounded-xl bg-[#0A192F]/10 text-[#0A192F] group-hover:bg-white group-hover:text-[#0A192F] flex items-center justify-center mb-6 transition-colors">
              <Icon className="w-7 h-7" />
            </div>
            <h3 className="text-xl font-semibold text-[#0A192F] group-hover:text-white transition-colors">
              {title}
            </h3>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default NationalProducts;
